import { Chip } from "@mui/material"

const CHIP_STYLES = {
    Red: { bgcolor: "#d32f2f", color: "#fff" },
    Pink: { bgcolor: "#e91e8c", color: "#fff" },
    Amber: { bgcolor: "#f59f00", color: "#fff" },
    Green: { bgcolor: "#2e7d32", color: "#fff" },
}

export function ClassificationChip({ item, index, getTagProps }) {
    const sx = CHIP_STYLES[item] ?? {}
    return (
        <Chip
            {...getTagProps({ index })}
            label={item}
            size="small"
            sx={{
                ...sx,
                "& .MuiChip-deleteIcon": { color: "rgba(255,255,255,0.7)", "&:hover": { color: "#fff" } },
            }}
        />
    )
}
